const user = {
  state: {
    userInfo:''
  },

  mutations: {
    USER_INFO: (state, token) => {
      state.userInfo = token
    }
  },

  actions: {
    // 登录
    setUserInfo({ commit }, userInfo) {
      commit('USER_INFO', userInfo)
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js